import styled from 'styled-components';

import { applyColorFromProps, IColorProps } from 'packages/kakapo-ui-kit/helpers/Theme';

export default styled.hr<IColorProps>`
	background-color: ${(props) => applyColorFromProps(props, 'lightBlue')} !important;
	width: 100%;
	height: 1px;
	border: 0;
	outline: 0;
	margin: 0;
`;
